import React from 'react'
import styled from '@emotion/styled'

import Row from 'modules/ui/atoms/Layout/Row'
import Column from 'modules/ui/atoms/Layout/Column'
import Label from 'modules/ui/atoms/Typography/Label'
import InputField from 'modules/ui/molecules/FormComponents/InputField'
import { useFormContext } from 'react-hook-form'
import RadioButtonInput from 'modules/ui/atoms/RadioButton/RadioButtonInput'
import { DedicationFormData } from './order-dedication-drawer-panel'
import { useTranslation } from 'next-i18next'

const OrderDedicationHonoreeFieldsContainer = styled.div`
  height: 40px;
  display: flex;
  justify-content: flex-start;
  gap: 8px;
`

const RadioButtonsWrapper = styled.div`
  display: flex;
  border-radius: 8px;
  border: none;
  gap: 8px;
  align-items: center;
  justify-content: center;
`

const StyledLabel = styled(Label)`
  padding-left: 8px;
  cursor: pointer;
  @media (max-width: 768px) {
    padding-left: 0px;
  }
`

const OrderDedicationHonoreeFields = () => {
  const { t } = useTranslation()

  const form = useFormContext<DedicationFormData>()

  const type = form.watch('type')

  const onChange = (type: DedicationFormData['type']) => {
    form.setValue('type', type)
  }

  return (
    <div>
      <OrderDedicationHonoreeFieldsContainer role="radiogroup">
        <RadioButtonsWrapper>
          <RadioButtonInput
            id="OrderDedicationHonoreeFields"
            name="memory"
            type="radio"
            value="memory"
            checked={type === 'memory'}
            onChange={() => onChange('memory')}
            aria-label={t('OrderDedicationHonoreeFields.inMemory.ariaLabel', 'In memory of')}
            data-id="dedication-honoree-in-memory-of-radio"
          />
          <StyledLabel onClick={() => onChange('memory')}>
            {t('OrderDedicationHonoreeFields.inMemory.label', 'In memory of...')}
          </StyledLabel>
        </RadioButtonsWrapper>
        <RadioButtonsWrapper>
          <RadioButtonInput
            id="OrderDedicationHonoreeFields"
            type="radio"
            value="honor"
            checked={type === 'honor'}
            onChange={() => onChange('honor')}
            name="honor"
            aria-label={t('OrderDedicationHonoreeFields.inHonor.ariaLabel', 'In honor of')}
            data-id="dedication-honoree-in-honor-of-radio"
          />
          <StyledLabel onClick={() => onChange('honor')}>
            {t('OrderDedicationHonoreeFields.inHonor.label', 'In honor of...')}
          </StyledLabel>
        </RadioButtonsWrapper>
      </OrderDedicationHonoreeFieldsContainer>

      <Row style={{ marginTop: '4px', marginBottom: '8px' }}>
        <Column>
          <InputField
            required
            id="honoreeFirstName"
            dataId="dedication-honoree-first-name-input"
            label={t('OrderDedicationHonoreeFields.HonoreeFirstNameField.label', 'First name')}
            error={form.formState.errors.honoreeFirstName as { message: string }}
          />
        </Column>
        <Column>
          <InputField
            required
            id="honoreeLastName"
            dataId="dedication-honoree-last-name-input"
            label={t('OrderDedicationHonoreeFields.HonoreeLastNameField.label', 'Last name')}
            error={form.formState.errors.honoreeLastName as { message: string }}
          />
        </Column>
      </Row>
    </div>
  )
}

export default OrderDedicationHonoreeFields
